import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Form,
  Button,
  Dropdown,
  Divider,
  Label,
  Checkbox,
  TextArea,
  Message
} from "semantic-ui-react";
import moment from "moment";
import "./loader.css";
class EmployeeForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      employee: null,
      editing: true,
      reportsTo: null,
      resetpassword: false
    };
  }

  genreportsto() {
    if (this.props.employee.reportsto && this.props.jtadmins.length) {
      let value = this.props.jtadmins.find(
        jt => jt.empnumber === this.props.employee.reportsto
      );
      return value;
    }
  }
  ungenmsg() {
    setTimeout(() => {
      this.setState({ resetpassword: false });
    }, 5000);
  }
  genmsg() {
    if (this.state.resetpassword) {
      this.ungenmsg();
      return (
        <Message
          info
          header="Password Reset"
          content={
            "Password for " +
            this.props.employee.firstname +
            " " +
            this.props.employee.lastname +
            " has been successfully reset."
          }
        />
      );
    }
  }
  componentDidUpdate(prevProps, prevState) {
    console.log(this.props.newcontact);
  }
  render() {
    let reportsTo = this.genreportsto();
    let employee = this.props.employee;
    return (
      <div className="EmployeeForm">
        <Grid>
          <Grid.Column width={10}>{this.genmsg()}</Grid.Column>
          <Grid.Column width={3}>
            <Button
              id="billingsavebtn"
              color="green"
              onClick={() => this.props.handlesave(this.props.employee)}
            >
              Save
            </Button>

            <Button
              id="billingsavebtn"
              disabled={this.props.newcontact}
              color="blue"
              onClick={() => this.props.resetpassword()}
            >
              Reset Password
            </Button>

            <Button
              id="billingsavebtn"
              onClick={() => this.setState({ editing: false })}
            >
              Cancel
            </Button>
          </Grid.Column>
        </Grid>
        <Divider />
        <Form>
          <Grid>
            <Grid.Column width={2} textAlign="center">
              <Label size="large">
                Employee Number: {"  " + employee.empnumber}
                <br />
                Login ID: {"  " + employee.userid}
              </Label>
            </Grid.Column>
            <Grid.Column width={10}>
              <Form.Group>
                <Form.Input
                  width={16}
                  label="Firstname"
                  value={employee.firstname}
                  onChange={e => {
                    this.props.update("firstname", e.target.value);
                  }}
                />
                <Form.Input
                  width={16}
                  label="Last Name"
                  value={employee.lastname}
                  onChange={e => {
                    this.props.update("lastname", e.target.value);
                  }}
                />
              </Form.Group>
              <Form.Group>
                <Form.Input
                  width={2}
                  label="Initial"
                  value={employee.minitial}
                  onChange={e => {
                    this.props.update("minitial", e.target.value);
                  }}
                />
                <Form.Input
                  width={4}
                  type="date"
                  label="DOB"
                  value={employee.dob}
                  onChange={e => {
                    this.props.update(
                      "dob",
                      moment(e.target.value).format("YYYY-MM-DD")
                    );
                  }}
                />
              </Form.Group>
              <Form.Group>
                <Form.Input
                  width={4}
                  label="Cell Phone #"
                  value={employee.cellphonenumber}
                  onChange={e => {
                    this.props.update("cellphonenumber", e.target.value);
                  }}
                />
                <Form.Input
                  width={4}
                  label="Work Phone #"
                  value={employee.workphone}
                  onChange={e => {
                    this.props.update("workphone", e.target.value);
                  }}
                />
                <Form.Input
                  width={4}
                  label="Work Fax #"
                  value={employee.workfax}
                  onChange={e => {
                    this.props.update("workfax", e.target.value);
                  }}
                />
                <Form.Input
                  width={4}
                  label="Beeper #"
                  value={employee.beepernumber}
                  onChange={e => {
                    this.props.update("beepernumber", e.target.value);
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Input
                  fluid
                  label="Work Email"
                  value={employee.workemail}
                  onChange={e => {
                    this.props.update("workemail", e.target.value);
                  }}
                />

                <Form.Input
                  fluid
                  label="Home Email"
                  value={employee.homeemail}
                  onChange={e => {
                    this.props.update("homeemail", e.target.value);
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <label>Discipline Code</label>
                  <Dropdown
                    placeholder="Code"
                    fluid
                    search
                    selection
                    value={employee.discipline}
                    options={[
                      { key: "ADMIN", value: "ADMIN", text: "ADMIN" },
                      {
                        key: "ANALY ENG",
                        value: "ANALY ENG",
                        text: "ANALY ENG"
                      },
                      {
                        key: "COMP PROG",
                        value: "COMP PROG",
                        text: "COMP PROG"
                      },
                      { key: "DESIGNER", value: "DESIGNER", text: "DESIGNER" },
                      { key: "FAC ENGR", value: "FAC ENGR", text: "FAC ENGR" },
                      { key: "FORMAN", value: "FORMAN", text: "FORMAN" },
                      { key: "GC", value: "GC", text: "GC" },
                      {
                        key: "INSPECTOR",
                        value: "INSPECTOR",
                        text: "INSPECTOR"
                      },
                      { key: "LABORER", value: "LABORER", text: "LABORER" },
                      { key: "PE", value: "PE", text: "PE" },
                      { key: "PROJ ENG", value: "PROJ ENG", text: "PROJ ENG" },
                      {
                        key: "PROJ MANG",
                        value: "PROJ MANG",
                        text: "PROJ MANG"
                      },
                      { key: "SPEC CON", value: "SPEC CON", text: "SPEC CON" },
                      { key: "TECH", value: "TECH", text: "TECH" }
                    ]}
                    onChange={(e, { value }) => {
                      console.log(value);
                      this.props.update("discipline", value);
                    }}
                  />
                </Form.Field>

                <Form.Field>
                  <label>Reports To</label>
                  <Dropdown
                    placeholder="JT Admin"
                    fluid
                    search
                    selection
                    value={employee.reportsto}
                    options={this.props.jtlist}
                    onChange={(e, { value }) => {
                      console.log(value);
                      this.props.update("reportsto", value);
                    }}
                  />
                </Form.Field>
                <Form.Field>
                  <label>Activity</label>
                  <Dropdown
                    placeholder="JT Admin"
                    fluid
                    search
                    selection
                    value={employee.emp_stat}
                    options={[
                      {
                        key: "FT SAL",
                        value: "FT SAL",
                        text: "Full Time Salary"
                      },
                      {
                        key: "FT HR",
                        value: "FT HR",
                        text: "Full Time Hourly"
                      },
                      {
                        key: "PT HR",
                        value: "PT HR",
                        text: "Part Time Hourly"
                      },
                      {
                        key: "SEA",
                        value: "SEA",
                        text: "Seasonal"
                      },
                      {
                        key: "IND",
                        value: "IND",
                        text: "Independent"
                      },
                      {
                        key: "NR",
                        value: "NR",
                        text: "Not on Record"
                      }
                    ]}
                    onChange={(e, { value }) => {
                      console.log(value);
                      this.props.update("emp_stat", value);
                    }}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group>
                <Form.Input
                  width={16}
                  label="Street Address"
                  value={employee.streetaddress}
                  onChange={e => {
                    this.props.update("streetaddress", e.target.value);
                  }}
                />
              </Form.Group>
              <Form.Group>
                <Form.Input
                  width={6}
                  label="City"
                  value={employee.city}
                  onChange={e => {
                    this.props.update("city", e.target.value);

                    employee.city = e.target.value;
                    this.setState({ employee });
                  }}
                />
                <Form.Input
                  width={3}
                  label="State"
                  value={employee.state}
                  onChange={e => {
                    this.props.update("state", e.target.value);

                    employee.state = e.target.value;
                    this.setState({ employee });
                  }}
                />
                <Form.Input
                  width={3}
                  label="Zip Code"
                  value={employee.zipcode}
                  onChange={e => {
                    this.props.update("zipcode", e.target.value);

                    employee.zipcode = e.target.value;
                    this.setState({ employee });
                  }}
                />
              </Form.Group>
              <Form.Group>
                <Form.Checkbox
                  label="Job Tracker Admin"
                  name="workorderContractLabor"
                  value={employee.jtadmin}
                  toggle
                  checked={employee.jtadmin}
                  onChange={(e, { value }) => {
                    let newvalue = 1 - value;
                    console.log(newvalue);
                    this.props.update("jtadmin", newvalue);
                  }}
                />
                <Form.Checkbox
                  label="HR Admin"
                  name="workorderContractLabor"
                  toggle
                  value={employee.hradmin}
                  checked={employee.hradmin}
                  onChange={(e, { value }) => {
                    let newvalue = 1 - value;
                    console.log(newvalue);
                    this.props.update("hradmin", newvalue);
                  }}
                />
                <Form.Checkbox
                  label="Labor System Admin"
                  toggle
                  name="workorderContractLabor"
                  value={employee.lsadmin}
                  checked={employee.lsadmin}
                  onChange={(e, { value }) => {
                    let newvalue = 1 - value;
                    console.log(newvalue);
                    this.props.update("lsadmin", newvalue);
                  }}
                />{" "}
                      <Form.Checkbox
                  label="Overtime Eligible"
                  toggle
                  name="overtime"
                  value={employee.overtime_empnumber}
                  checked={employee.overtime_empnumber}
                  onChange={(e, { value }) => {
                    this.props.update("overtime_empnumber", employee.overtime_empnumber? 0: 1);

                     
                  }}
                />
                <Form.Checkbox
                  label={
                    "Status: " +
                    (employee.status === "A" ? "Active" : "Inactive")
                  }
                  value={employee.status}
                  toggle
                  checked={employee.status === "A"}
                  onChange={(e, { value }) => {
                    let options = ["A", "I"];
                    console.log(value);
                    this.props.update(
                      "status",
                      options[1 - options.indexOf(value)]
                    );
                  }}
                />
              </Form.Group>
              <Divider />
              <Form.Group>
                <Form.Input
                  width={8}
                  label="Emergency Contact"
                  value={employee.emercontact}
                  onChange={e => {
                    this.props.update("emercontact", e.target.value);
                  }}
                />
              </Form.Group>
              <Form.Group>
                <Form.Input
                  width={4}
                  label="Phone #"
                  value={employee.emerphonenumber}
                  onChange={e => {
                    this.props.update("emerphonenumber", e.target.value);
                  }}
                />
              </Form.Group>
              <Divider />
              <Form.Group>
                <Form.Input
                  width={8}
                  label="2nd Emergency Contact"
                  value={employee.emercontact2}
                  onChange={e => {
                    this.props.update("emercontact2", e.target.value);
                  }}
                />
              </Form.Group>
              <Form.Group>
                <Form.Input
                  width={4}
                  label="Phone #"
                  value={employee.emerphonenumber2}
                  onChange={e => {
                    this.props.update("emerphonenumber2", e.target.value);
                  }}
                />
              </Form.Group>
              <Divider />
              <Form.Group>
                <Form.Field>
                  <label>Paid Time Off</label>
                  <Dropdown
                    placeholder="Exempt"
                    fluid
                    search
                    selection
                    value={employee.ptoexempt}
                    options={[
                      {
                        key: 0,
                        value: 0,
                        text: "No PTO"
                      },
                      {
                        key: 10.8,
                        value: 10.8,
                        text: "10.8 hrs/PTO hour"
                      },
                      {
                        key: 14.3,
                        value: 14.3,
                        text: "14.3  hrs/PTO hour"
                      },
                      {
                        key: 22.5,
                        value: 22.5,
                        text: "22.5  hrs/PTO hour"
                      }
                    ]}
                    onChange={(e, { value }) => {
                      console.log(value);
                      this.props.update("ptoexempt", value);
                    }}
                  />
                </Form.Field>
                <Form.Input
                  width={4}
                  label="PTO BALANCE"
                  value={employee.ptobalance}
                />
                <Form.Input
                  width={4}
                  label="PTO Carryover"
                  value={employee.ptocarryover}
                  onChange={e => {
                    this.props.update("ptocarryover", e.target.value);
                  }}
                />
                <Form.Input
                  width={4}
                  type="date"
                  label="PTO Start date"
                  value={employee.ptodate}
                  onChange={e => {
                    this.props.update(
                      "ptodate",
                      moment(e.target.value).format("YYYY-MM-DD")
                    );
                  }}
                />
              </Form.Group>
              <Form.Group>
                <Form.Input
                  width={4}
                  type="date"
                  label="Hire Date"
                  value={employee.hiredate}
                  onChange={e => {
                    this.props.update(
                      "hiredate",
                      moment(e.target.value).format("YYYY-MM-DD")
                    );
                  }}
                />
                <Form.Input
                  width={4}
                  type="date"
                  label="Termination date"
                  value={employee.termdate}
                  onChange={e => {
                    this.props.update(
                      "termdate",
                      moment(e.target.value).format("YYYY-MM-DD")
                    );
                  }}
                />
              </Form.Group>

              <Form.Group>
                <Form.Input
                  width={4}
                  type="date"
                  label="Re-Hire Date"
                  value={employee.rehiredate}
                  onChange={e => {
                    this.props.update(
                      "rehiredate",
                      moment(e.target.value).format("YYYY-MM-DD")
                    );
                  }}
                />
                <Form.Input
                  width={4}
                  type="date"
                  label="Re-Termination date"
                  value={employee.retermdate}
                  onChange={e => {
                    this.props.update(
                      "retermdate",
                      moment(e.target.value).format("YYYY-MM-DD")
                    );
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <label>Comments</label>
                  <TextArea
                    value={employee.payrollcomments}
                    fluid
                    onChange={e => {
                      this.props.update("payrollcomments", e.target.value);
                    }}
                  />
                </Form.Field>
              </Form.Group>
            </Grid.Column>
          </Grid>
        </Form>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    jtadmins: state.employees.jtadmins
  };
}
export default connect(mapStateToProps)(EmployeeForm);



// WEBPACK FOOTER //
// ./src/components/shared-components/employeeform.js